// tslint:disable:directive-selector
import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[drag-and-drop-files]'
})
export class DragDropFilesDirective {

    @Output() dropFiles = new EventEmitter<FileList>();
    @Output() dragoverFiles = new EventEmitter<void>();

    @HostListener('dragover', ['$event'])
    onDragOver(e: Event): void {
        e.preventDefault();
        e.stopPropagation();
        this.dragoverFiles.emit(undefined);
    }

    @HostListener('dragenter', ['$event'])
    onDragEnter(e: Event): void {
        e.preventDefault();
        e.stopPropagation();
    }

    @HostListener('drop', ['$event'])
    onDrop(e): void {
        e.preventDefault();
        e.stopPropagation();
        this.dropFiles.emit(e.dataTransfer.files);
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/drag-drop-files.directive.ts